export const PRODUCT_SET_DISPLAY_PRICE = 'PRODUCT_SET_DISPLAY_PRICE';
